<template>
    <div class="page about">
        <div class="about-top">
            <img :src="bannerList[0]?.img || require('@/assets/homeMb/about-top.png')" alt="">
            <div class="carousel-information" @click="openInquiryForm">
                <img src="../../assets/home/xinxi.png" alt="">
            </div>
        </div>
        <div class="about-top-record">
            <div class="about-top-record-item" v-for="(item,index) in pageData[0]?.value" :key="index">
                <div class="image">
                    <img :src=" item?.icon || require('../../assets/about/brand-1.png')"></img>
                </div>
                <div class="text-box">
                    <div class="text-title">{{ item.title }}</div>
                    <div class="text-line"></div>
                    <div class="text-bottom">{{ item.content }}</div>
                </div>
            </div>
            <!-- <div class="about-top-record-item">
                <div class="image">
                    <img src="../../assets/about/brand-1.png"></img>
                </div>
                <div class="text-box">
                    <div class="text-title">{{ $t('about.topCount.title1') }}</div>
                    <div class="text-line"></div>
                    <div class="text-bottom">{{ $t('about.topCount.bottom1') }}</div>
                </div>
            </div>
            <div class="about-top-record-item">
                <div class="image">
                    <img src="../../assets/about/brand-2.png"></img>
                </div>
                <div class="text-box">
                    <div class="text-title">{{ $t('about.topCount.title2') }}</div>
                    <div class="text-line"></div>
                    <div class="text-bottom">{{ $t('about.topCount.bottom2') }}</div>
                </div>
            </div>
            <div class="about-top-record-item">
                <div class="image">
                    <img src="../../assets/about/brand-3.png"></img>
                </div>
                <div class="text-box">
                    <div class="text-title">{{ $t('about.topCount.title3') }}</div>
                    <div class="text-line"></div>
                    <div class="text-bottom">{{ $t('about.topCount.bottom3') }}</div>
                </div>
            </div> -->
        </div>
        <!-- ABOUT company -->
        <div class="about-company">
            <div class="area-title-mobile">
                <p class="area-titleTop-mobile">{{ pageData[1]?.value[0]?.title }}</p>
                <p class="area-titleBottom-mobile">{{ pageData[1]?.value[0]?.subheading }}</p>
            </div>
            <div class="about-company-content">
                <div class="about-company-image">
                    <img :src="pageData[1]?.value[0]?.img" alt=""></img>
                </div>
                <div class="about-company-introduction">
                    <p class="about-company-introduction-title1">{{ pageData[1]?.value[0]?.content_title }}</p>
                    <!-- <p class="about-company-introduction-title2">{{ pageData[1]?.value[0]?.content_subheading }}
                    </p> -->
                    <p class="about-company-introduction-content">{{ pageData[1]?.value[0]?.conttent_content }}</p>
                </div>
            </div>
        </div>
        <!--ABOUT Service Idea  -->
        <div class="about-service">
            <div class="area-title-mobile">
                <div class="area-titleTop-mobile">{{ pageData[2]?.value[0]?.title }}</div>
                <!-- <div class="area-titleBottom-mobile">{{ pageData[2]?.value[0]?.Subheading }}</div> -->
            </div>
            <div class="swiper-wrapper-box">
                <swiper :options="serviceSwiperOptions" class="about-service-swiper">
                    <!-- <swiper-slide class="slide">
                        <img src="../../assets/about/service-2.png" alt="" />
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <img src="../../assets/about/service-3.png" alt="" />
                    </swiper-slide>
                    <swiper-slide class="slide">
                        <img src="../../assets/about/service-1.png" alt="" />
                    </swiper-slide> -->
                    <swiper-slide class="slide" v-for="item in pageData[2]?.value[0]?.content" :key="item">
                        <img :src="item.img" alt="">
                        <div style="position: absolute;top:20px;left:20px;font-size: 5vw;">
                           <strong>{{ item.title }}</strong> 
                        </div>
                    </swiper-slide>

                </swiper>

                <div class="indicators">
                    <div :class="['item', ServiceIndex === index ? 'active' : '']"
                        v-for="(_, index) in pageData[2]?.value[0]?.content.length" :key="index">
                    </div>
                </div>
            </div>

        </div>
        <!-- ABOUT Team Message-->
        <div class="about-team">
            <div class="area-title-mobile">
                <div class="area-titleTop-mobile">{{ pageData[3]?.value[0]?.title }}</div>
                <div class="area-titleBottom-mobile">{{ pageData[3]?.value[0]?.subheading }}</div>
            </div>
            <div class="about-team-message">
                <div class="about-team-message-item" v-for="(item,index) in pageData[3]?.value[0]?.content" :key="index">
                    <div class="item-avatar">
                        <img :src="item.avatar" alt="">
                    </div>
                    <div class="item-card">
                        <div class="item-name">{{ item.name }}</div>
                        <div class="item-sub">{{ item.introduction }}</div>
                        <p class="item-text" v-html="item.content"></p>
                        <!-- <p class="item-text">{{ $t('about.teamMessageCount.veroniceIntroductionContent2') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.veroniceIntroductionContent3') }}</p> -->
                    </div>
                </div>
                <!-- <div class="about-team-message-item">
                    <div class="item-avatar">
                        <img src="../../assets/about/team-1.png" alt="">
                    </div>
                    <div class="item-card">
                        <div class="item-name">{{ $t('about.teamMessageCount.veroniceName') }}</div>
                        <div class="item-sub">{{ $t('about.teamMessageCount.veroniceIntroduction') }}</div>
                        <p class="item-text">{{ $t('about.teamMessageCount.veroniceIntroductionContent1') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.veroniceIntroductionContent2') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.veroniceIntroductionContent3') }}</p>
                    </div>
                </div>
                <div class="about-team-message-item">
                    <div class="item-avatar">
                        <img src="../../assets/about/team-2.png" alt="">
                    </div>
                    <div class="item-card">
                        <div class="item-name">{{ $t('about.teamMessageCount.memberName') }}</div>
                        <div class="item-sub">{{ $t('about.teamMessageCount.memberIntroduction') }}</div>
                        <p class="item-text">{{ $t('about.teamMessageCount.memberIntroductionContent1') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.memberIntroductionContent2') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.memberIntroductionContent3') }}</p>
                    </div>
                </div>
                <div class="about-team-message-item">
                    <div class="item-avatar">
                        <img src="../../assets/about/team-3.png" alt="">
                    </div>
                    <div class="item-card">
                        <div class="item-name">{{ $t('about.teamMessageCount.jackName') }}</div>
                        <div class="item-sub">{{ $t('about.teamMessageCount.jackIntroduction') }}</div>
                        <p class="item-text">{{ $t('about.teamMessageCount.jackIntroductionContent1') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.jackIntroductionContent2') }}</p>
                        <p class="item-text">{{ $t('about.teamMessageCount.jackIntroductionContent3') }}</p>
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import '@/components/common.css';
import { bus } from '@/utils/bus';
import { getDataList,getBannerListingMobile } from '@/api/komo.js';
let vm = null
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            ServiceIndex: 0, // 当前轮播索引
            serviceSlides: [
                {
                    id: 1,
                    imgUrl: require('@/assets/about/service-1.png'),
                },
                {
                    id: 2,
                    imgUrl: require('@/assets/about/service-2.png'),
                },
                {
                    id: 3,
                    imgUrl: require('@/assets/about/service-3.png'),
                },
            ],
            serviceSwiperOptions: {
                pagination: {
                    el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
                    clickable: true, // 允许点击分页器切换幻灯片
                    // bulletActiveClass: 'home-swiper-one-active' // 自定义激活的分页器类名
                },
                on: {
                    // 滑动改变时触发
                    slideChange: function () {
                        vm.ServiceIndex = this.realIndex
                    }
                },
                autoplay: {
                    delay: 5000, // 自动切换时间间隔
                    disableOnInteraction: true // 用户操作后是否停止自动切换，默认为true
                },
                centeredSlides: true,
                loop: true, // 无限循环
                loopAdditionalSlides: 1, // 循环时额外复制的slide数量
                slideToClickedSlide: true, // 点击slide直接切换
                slidesPerView: 1.2, // 一次显示3个 slides
                spaceBetween: 20, // 设置 slides 之间的间距
            },
            bannerList: [], //banner数据
            pageData: [] //页面数据
        }
    },
    methods: {
        async initData(){
			const res = await getBannerListingMobile('2')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}

			const res1 = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res1?.data?.list || []
		},
        // 打开全局表单
        openInquiryForm() {
            bus.$emit('inquiry-form', true)
        },
    },
    created() {
        vm = this // 保存当前实例引用
        this.initData()
    },
    mounted() {
        // this.getBannerData()
        // this.getDataList()
    },
}
</script>
<style scoped>
.about {
    width: 100%;
    height: 100%;
}

.about-top {
    width: 100%;
    height: auto;
    position: relative;
}

.about-top img {
    width: 100%;
    height: 100%;
}

.about-top .carousel-information {
    position: fixed;
     bottom:3%;
    right: 3%;
    width: 25vw;
    height: 25vw;
    cursor: pointer;
    z-index: 999;
}

.about-top .carousel-information img {
    width: 100%;
    height: 100%;
}

/* 顶部图片下方描述 */
.about-top-record {
    width: 100%;
    background: #F8F9FC;
    padding: 10px 20px;
}

.about-top-record-item {
    width: 100%;
    padding: 20px 0;
    display: flex;
    flex-direction: row;
}

.about-top-record-item .image {
    width: 15vw;
    height: 15vw;
    flex: 0 0 15vw;
}

.about-top-record-item .image img {
    width: 100%;
    height: 100%;

}

.about-top-record-item .text-box {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
}

.about-top-record-item .text-box .text-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 4vw;
    color: #1E1E1E;
    text-align: left;
    font-style: normal;
}

.about-top-record-item .text-box .text-line {
    width: 10vw;
    height: 3px;
    background: #D5DCC8;
    margin: 5vw 0;
}

.about-top-record-item .text-box .text-bottom {
    font-family: MicrosoftYaHei;
    font-size: 2.5vw;
    color: #333333;
    /* text-align: left; */
    font-style: normal;
}

/* ABOUT company */
.about-company {
    width: 100%;
    background: #F8F9FC;
    padding: 20px 20px;
}

.about-company-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.about-company-content .about-company-image {
    width: 90%;
    height: auto;
    z-index: 10;
}

.about-company-content .about-company-image img {
    width: 100%;
    height: 100%;
}

.about-company-content .about-company-introduction {
    width: 100%;
    background: #ECECEC;
    border-radius: 10px;
    margin-top: -30px;
    padding-top: 50px;
    /* padding: 0 5%; */
}

.about-company-introduction-title1 {
    text-align: center;
    font-weight: bold;
    font-size: 5vw;
    color: #1E1E1E;
}

.about-company-introduction-title2 {
    text-align: center;
    font-weight: bold;
    font-size: 4vw;
    color: #1E1E1E;
}

.about-company-introduction-content {
    font-size: 3vw;
    color: #959595;
    padding: 0 3%;
}

/* ABOUT Service Idea */
.about-service {
    width: 100%;
    background: #D5DCC8;
    padding: 0 0 10% 0;
}

.about-service .swiper-wrapper-box {
    width: 100%;
}

.about-service .swiper-wrapper-box .swiper-slide {
    width: 100%;
    height: 100%;
}

.about-service .swiper-wrapper-box .about-service-swiper .slide img {
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}

.about-service .indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5% 0 0;
}

.about-service .indicators .item {
    width: 50px;
    height: 6px;
    border-radius: 8px;
    margin-left: 10px;
    background: #959595;
}

.about-service .indicators .active {
    background: #1e1e1e;
}

/*  ABOUT Team Message  */
.about-team {
    width: 100%;
    background: #F8F9FC;
}

.about-team-message {
    width: 100%;
    padding: 20px 40px 20px;
}

.about-team-message .about-team-message-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding-left: 9%;
    background: #E9E9E9;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    color: #2f3b34;
    border-radius: 12px;
    margin-bottom: 50px;
}


.about-team-message-item .item-avatar {
    position: absolute;
    width: 72px;
    height: 72px;
    flex: 0 0 72px;
    margin-left: 8px;
    /* top: -10%;
    left: -12%; */
    top: -35px;
    left: -35px;
}

.item-avatar img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    position: relative;
    z-index: 2;
    margin: 4px;
}

.about-team-message-item .item-card {
    padding: 14px;
    color: #2f3b34;
    flex: 1;
}

.item-name {
    font-weight: 800;
    color: #567157;
    font-size: 5vw;
}

.item-sub {
    font-weight: 700;
    font-size: 4vw;
    margin-top: 6px;
}

.item-text {
    margin: 0;
    color: #5e6b63;
    font-size: 3vw;
}
</style>